export const pricing = {
  seo: {
    title: "Tarifs – à partir de 0 € par mois | Bistroo",
    description: "Aucun frais de démarrage. Choisissez un module gratuit ou un abonnement payant. Découvrez tous les tarifs Bistroo et démarrez dès aujourd'hui.",
  },
  hero: {
    heading: {
      serve: 'Nous proposons',
      flexible: 'des tarifs flexibles',
      scales: 'qui évoluent avec vous',
    },
    choose: 'Composez un forfait qui correspond le mieux à votre restaurant.',
    switch: 'Passez des tarifs d\'abonnement aux tarifs par volume.',
    billing: {
      monthly: 'Mensuel',
      yearly: 'Annuel',
      badge: '20 % de remise',
      badge_short: '-20 %',
    },
  },

  content: {
    build: {
      title: 'Composez votre forfait',
      text: [
        {
          the: 'Le',
          first: 'premier produit coûte 39 €',
          month: 'par mois.',
          additional: 'Chaque produit supplémentaire coûte 15 €',
          added: 'par mois en plus du prix de base.',
        },
        {
          no: 'Pas d\'abonnement mensuel.',
          pay: 'Ne payez que des frais de volume sur la valeur de vos commandes.',
          all: 'Tous les modules complémentaires sont inclus gratuitement',
        },
      ],
      base: ['€ 39', '€ 0'],
      extra: ['€ 15', '€ 0'],
    },
    contact: {
      title: 'Nous contacter',
      text: 'Avez-vous des questions ou besoin d\'une solution sur mesure ?',
      cta: 'Prendre contact',
    },
    first: {
      title: ['Premier produit', 'Produits & modules gratuits'],
      price: ['€ 39', '€ 0'],
      month: 'Mois',
    },
    toggle: {
      subscription: 'Abonnement',
      volumefee: 'Volume-fee',
    },
  },

  plans: {
    website: {
      title: 'Website',
      price: ['€ 15', '7%'],
      period: ['/ mois', '/ commande'],
      subtitle: 'Boutique en ligne ou site web',
      description:
        'Site web professionnel pour la restauration, bien référencé sur Google et intégré à votre boutique Bistroo',
      enabledFeatures: [
        'Boutique en ligne incluse',
        'Design responsive à votre charte graphique',
        'Optimisation SEO & Google',
        'Hébergement, maintenance et sauvegardes inclus',
        'Autogestion via le Bistroo Manager',
      ],
      start: 'Commencer gratuitement',
    },
    webshop: {
      title: 'Webshop',
      price: ['€ 15', '7%'],
      period: ['/ mois', '/ commande'],
      subtitle: 'Boutique en ligne ou QR',
      description:
        'Boutique en ligne complète pour la vente à emporter et la livraison, à votre image et entièrement intégrée à votre site web',
      enabledFeatures: [
        'Menu interactif avec options d\'upsell',
        'Créneaux horaires et gestion des capacités',
        'Zones de livraison dessinées sur carte',
        'Tous les modes de paiement pertinents',
        'Autogestion via le Bistroo Manager',
      ],
      start: 'Commencer gratuitement',
    },
    pos: {
      title: 'Caisse',
      price: ['€ 15', '1,49%'],
      period: ['/ mois', '/ commande'],
      subtitle: 'Boutique en ligne et site web',
      description:
        'Caisse ultrarapide, développée pour les restaurants de service rapide. Commander et payer en un tour de main',
      enabledFeatures: [
        'Système de caisse plug-and-play',
        'Saisie rapide des commandes avec options',
        'Tickets cuisine et client',
        'PIN, sans contact et paiements partagés',
        'Clôture de service et de journée avec rapport Z',
        'Autogestion via le Bistroo Manager',
      ],
      start: 'Demander',
    },
    kiosk: {
      title: 'Kiosk',
      price: ['€ 15', '1,49%'],
      period: ['/ mois', '/ commande'],
      subtitle: 'Boutique en ligne et site web',
      description:
        'Borne de commande libre-service. Files d\'attente réduites, upsell constant, dépense moyenne plus élevée',
      enabledFeatures: [
        'Design interactif à votre charte graphique',
        'Accrocheur et favorisant la conversion',
        'Suggestions d\'upsell et de cross-sell',
        'Finalisation avec numéro de commande et ticket',
        'PIN, sans contact et paiements mobiles',
        'Autogestion via le Bistroo Manager',
      ],
      start: 'Demander',
    },
    qr: {
      title: 'QR',
      price: ['€ 15', '3,49%'],
      period: ['/ mois', '/ commande'],
      subtitle: 'Boutique en ligne et site web',
      description:
        'Laissez les clients commander et payer eux-mêmes. Moins d\'attente, plus de rotations, addition moyenne plus élevée',
      enabledFeatures: [
        'Commander et payer directement à table',
        'Menu interactif avec options d\'upsell',
        'QR codes liés aux tables',
        'Option pourboire',
        'Autogestion via le Bistroo Manager',
      ],
      start: 'Commencer gratuitement',
    },
    enterprise: {
      title: 'Enterprise',
      price: ['Sur mesure', 'Sur mesure'],
      period: ['prix', 'prix'],
      subtitle: 'Composez votre forfait',
      description:
        'Solutions sur mesure pour les chaînes et les grands restaurants avec plusieurs établissements',
      enabledFeatures: [
        'Offre personnalisée',
        'Versements et facturation automatiques',
        'Interlocuteur dédié',
        'Gestion de plusieurs établissements',
        'Enterprise Bistroo Manager',
      ],
      start: 'Nous contacter',
    },
  },
}
